export default __webpack_public_path__ + "static/media/HOBIT-logo-basic.cdbc8705.png";